import * as _ from 'lodash';

import { Box, Flex, Image, Input, Text } from 'theme-ui';
import React, { useState } from 'react';
import { bool, string } from 'prop-types';
import { matchPath, useLocation, useParams } from 'react-router';

import { Image as AntImage } from 'antd';
import { CloseCircle } from '@styled-icons/evaicons-solid/CloseCircle';
import { ErrorMessage } from '@hookform/error-message';
import { Inline } from '@bedrock-layout/inline';
import { Stack } from '@bedrock-layout/stack';
import { UploadToCloud } from '@styled-icons/entypo/UploadToCloud';
import { useDropzone } from 'react-dropzone';
import { useFormContext } from 'react-hook-form';

function DropZone({ name, disabled = false, label }) {
  const params = useParams();
  const { pathname, ...rest } = useLocation();
  const { setValue, onDeleteLogo, formState, getValues } = useFormContext();
  const error = _.get(formState.errors, name);
  const { branch, identifier, homePageConfiguration } = getValues();
  const { logoFormat } = homePageConfiguration;

  const [didDelete, setDidDelete] = useState(false);
  const formHasFileRef = Array.isArray(getValues(name));

  const url = window.location.pathname;

  const [page, setPage] = useState({
    isView: url.includes('view'),
    isCreate: url.includes('create'),
    isNOTCreate: !url.includes('create'),
    isEdit: url.includes('edit'),
  });

  const [showCurrentPreview, setShowCurrentPreview] = useState(true);

  const [preview, setPreview] = React.useState([]);
  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    disabled,
    noKeyboard: true,
    accept: '.jpeg,.png, .jpg',
    onDrop: (acceptedFiles) => {
      setValue(name, acceptedFiles);
      setPreview(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const handleRemoveThumbnail = () => {
    setPreview([]);
    setValue(name, '');
  };

  const thumbnails = preview.map((file) => (
    <Flex key={file.name} sx={{ flexBasis: '25%' }} p="2">
      <Box>
        <Image src={file.preview} />
      </Box>
      <Box onClick={handleRemoveThumbnail} sx={{ marginLeft: '-10px', marginTop: '-10px' }}>
        <CloseCircle width={28} color="gray" />
      </Box>
    </Flex>
  ));

  const removeCurrentLogo = () => {
    setDidDelete(true);
    // onDeleteImage()
    onDeleteLogo();
  };

  const Preview = () => {
    const [hasError, setHasError] = useState(false);
    const branchName = branch === 'master' ? 'prod' : branch;

    if (window.location.pathname.includes('create') || formHasFileRef) return null;

    return (
      <Flex
        sx={{
          flexBasis: '25%',
        }}
        p="2"
      >
        <Box>
          {hasError === false && (
            <Image
              alt="foo"
              sx={{ maxWidth: '200px' }}
              src={`${process.env.REACT_APP_S3_BUCKET_URL}/tenants/${branchName}/${identifier}/logo/logo-tagline-en.${logoFormat}`}
            />
          )}

          <Image
            alt="foo"
            sx={{ maxWidth: '200px', visibility: 'hidden' }}
            src={`${process.env.REACT_APP_S3_BUCKET_URL}/tenants/${branchName}/${identifier}/logo/logo-tagline-en.${logoFormat}`}
            onError={() => setHasError(true)}
          />
          {hasError && (
            <>
              <AntImage
                width={200}
                height={200}
                src="error"
                fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
              />
              <Box>
                <Text>Uh oh, looks like the logo wasn&quot;t uploaded or no longer available.</Text>
              </Box>
            </>
          )}
        </Box>
        {showCurrentPreview && disabled === false && hasError !== true && (
          <Box onClick={removeCurrentLogo} sx={{ marginLeft: '-10px', marginTop: '-10px' }}>
            <CloseCircle width={28} color="gray" />
          </Box>
        )}
      </Flex>
    );
  };

  React.useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      preview.forEach((file) => {
        return URL.revokeObjectURL(file.preview);
      });
    },
    [preview]
  );

  React.useEffect(() => {
    setPage({
      isView: pathname.includes('view'),
      isCreate: pathname.includes('create'),
      isNOTCreate: !pathname.includes('create'),
      isEdit: pathname.includes('edit'),
    });
  }, []);

  return (
    <Stack gutter="md">
      {label && <Text variant="label">{label}</Text>}

      {page.isView === false && (
        <Box
          bg={error ? 'errorBackground' : 'disabledBackground'}
          p={4}
          borderColor="errorBorder"
          {...getRootProps({
            refKey: 'innerRef',
            minHeight: '140px',
            textAlign: 'center',
            borderRadius: '8px',
          })}
        >
          <Input {...getInputProps()} />
          <Stack gutter="md" onClick={open}>
            <Inline gutter="sm" align="center" justify="center">
              <UploadToCloud width="25" />
            </Inline>
            <Text sx={{ textAlign: 'center' }} variant="label">
              Click or drag file to this area to upload
            </Text>
          </Stack>
          <Box sx={{ pt: '24px' }}>
            <Inline gutter="md">{thumbnails}</Inline>
          </Box>
        </Box>
      )}
      <Preview />

      <ErrorMessage
        errors={formState.errors}
        name={name}
        render={(err) => (
          <Text key={err} color="errorText">
            {err.message}
          </Text>
        )}
      />
    </Stack>
  );
}

export const DropZonePropTypes = {
  name: string.isRequired,
  label: string,
  disabled: bool,
};

DropZone.propTypes = DropZonePropTypes;

export default DropZone;
